import React from 'react';
import { Database, Inbox } from 'lucide-react';

/**
 * A reusable component to display a consistent "No Data Found" message.
 * 
 * @param {string} message - The message to display.
 * @param {number} colSpan - Number of columns for table view.
 * @param {boolean} isTable - Whether to render as a table row or a standalone div.
 * @param {React.ElementType} icon - The Lucide icon to display (optional).
 */
const NoData = ({ 
  message = "No records found.", 
  colSpan = 100, 
  isTable = true,
  icon: Icon = Inbox
}) => {
  if (isTable) {
    return (
      <tr>
        <td colSpan={100} style={{ textAlign: 'center', padding: '100px', color: '#94a3b8' }}>
          <div style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
            <Icon size={40} style={{ opacity: 0.2 }} />
            <span style={{ fontSize: '14px', fontWeight: 500 }}>{message}</span>
          </div>
        </td>
      </tr>
    );
  }

  return (
    <div style={{ 
      textAlign: 'center', 
      padding: '40px', 
      color: '#94a3b8', 
      background: 'white', 
      borderRadius: '16px', 
      border: '1px solid #e2e8f0',
      margin: '16px 0',
      width: '100%'
    }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
        <Icon size={32} style={{ opacity: 0.2 }} />
        <span style={{ fontSize: '14px', fontWeight: 500 }}>{message}</span>
      </div>
    </div>
  );
};

export default NoData;
